module.exports = __webpack_public_path__ + "static/img/syicon_3.ed930ee8.svg";